import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink, View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import '../NavigationMobileMenuSubItem/style.scss';
import './style.scss';

const NavigationMobileMenuSubItemThemes = ({
  handleLinkClick,
  closeAllModals,
}) => {
  const { t } = useTranslation();

  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <div key="menu--main--sub-menu-item-themes">
      <div className="NavigationMainMenuMobile--subMenu__item NavigationMainMenuMobile--subMenu__item__theme">
        <CoreLink
          className="NavigationMainMenuMobile--subMenu__items__title"
        >
          <Container>
            <button type="button" className="NavigationMainMenu__subMenuPrefix" onClick={toggleOpen}>
              <h2>{t('tags.plural.theme')}</h2>
              <div className="icon icon-chevron-right" />
            </button>
          </Container>
        </CoreLink>

        <div
          className={`NavigationMainMenuMobile--subMenu__links ${isOpen ? 'mobile--subitem-open' : ''}`}
        >
          <Container>
            <button type="button" className="NavigationMainMenuMobile--submenu__back" onClick={toggleOpen}>
              <div className="icon icon-chevron-right" />
              {t('menu.back')}
            </button>
            <View
              id="vocabulary_terms"
              display="themes"
              showTitle={false}
              menuTeaser
              onClick={() => {
                handleLinkClick();
                toggleOpen();
              }}
            />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default NavigationMobileMenuSubItemThemes;
